var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Event extends Component {
    constructor() {
        super('Event', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $(window).on('resize', () => {
                this.resize();
            });
            this.resize();
            this.success();
        });
    }
    resize() {
        const column1End = $('#column_1_end').position().y;
        const column2End = $('#column_2_end').position().y;
        if ($(window).width() < 992) {
            $('#border-end').addClass('d-none');
        }
        else if (column1End > column2End) {
            $('#border-end').removeClass('d-none');
        }
        else {
            if ($('.embed').length > 0)
                $('#border-end').addClass('d-none');
        }
    }
}
